export const META_DATA_SLUG = {
  HOME_META_SLUG: 'home',
  PACKAGE_LITING_SLUG: 'explore',
  PRODUCT_DETAILS_SLUG: 'product-details',
  PRODUCT_REVIEW_SLUG: 'product-review',
  PHOTO_GALLERY: 'photo-gallery'
};
